// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_container__YQU9G","button":"PrivacyPolicy_button__ptZh+","title":"PrivacyPolicy_title__24C1-"};